import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://prophetesteeveorphoss.com";
const DEFAULT_IMAGE = `${SITE_URL}/prophete-hero.jpg`;

// Per-page SEO: title, meta description, canonical, Open Graph, Twitter, optional JSON-LD
export const Seo = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
  jsonLd,
}) => {
  const url = `${SITE_URL}${path}`;
  const fullTitle = title
    ? `${title} | Prophète Steeve Orphôss`
    : "Prophète Steeve Orphôss — Ministère Chrétien International";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large" />
      )}

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Prophète Steeve Orphôss" />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default Seo;
